module.exports = __webpack_public_path__ + "static/img/t1-3.5612ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1-3.jpg
// module id = cOFd
// module chunks = 1